/*
  Play video on scroll in view
*/

const videos = document.querySelectorAll('.play-on-scroll')

videos.forEach((video) => {
  // Create the observer
  let observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !video.getAttribute('data-played')) {
          video.play()
          video.setAttribute('data-played', 'true')
        }
      })
    },
    {
      root: null,
      rootMargin: '0px',
      threshold: 0.1,
    }
  )

  observer.observe(video)
})
